<template>
  <div v-if="laundryrooms.length !== 0" class="flex flex-col gap-4">
    <template v-for="contract in laundryrooms" :key="contract.id">
      <div>
        <input
          type="radio"
          name="rentalObjectCode"
          class="peer hidden"
          :key="contract.id"
          :value="contract.id"
          :id="contract.id"
          :checked="internalValue === contract.id"
          @change="onChange(contract.id)"
        />
        <Label :val="contract.id" :id="contract.id" :name="contract.name" :internalValue="internalValue" :onChange="onChange" />
      </div>
    </template>
  </div>
  <div v-else>Det verkar inte som du har tillgängliga val</div>
</template>

<script>
import Label from '@/components/ui/label';

export default {
  name: 'ChooseLaundryRoom',
  components: { Label },
  props: {
    rentalObjectCode: {
      type: String,
      required: true,
    },
    laundryCode: {
      type: String,
      required: true,
    },
    dir: {
      required: false
    }
  },
  data() {
    return {
      showLoader: false,
      internalValue: null,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.internalValue = value;
      },
    },
  },
  computed: {
    /**
     * Kontrakt, filtrerar på typ av area man valt.
     */
    laundryrooms() {
      return this.$store.getters.getLaundryRooms;
    },

  },
  methods: {
    onChange(value) {
      this.internalValue = value;
      this.$emit('update:laundryCode', value)
      this.$emit('change', value);
    },
  },
  created() {
    this.internalValue = this.laundryCode;
    if (this.laundryCode && this.dir =="prev") {
      this.$emit('update:laundryCode', this.internalValue);
      this.$emit('change', this.internalValue);
    }
  },
};
</script>
